module.exports = __webpack_public_path__ + "img/victron_65A.264d8272.png";